import * as React from 'react';
export const SpeakIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={14}
    viewBox="0 0 15 14"
    fill="none"
    {...props}
  >
    <g clipPath="url(#a)">
      <path
        fill="#C0C3D3"
        d="M8.543 8.998a3.938 3.938 0 1 0-4.867 0 6.786 6.786 0 0 0-2.663 1.955.656.656 0 0 0 1.005.844c.749-.891 2.068-1.953 4.091-1.953 2.024 0 3.343 1.062 4.092 1.953a.656.656 0 1 0 1.005-.844 6.781 6.781 0 0 0-2.663-1.955ZM3.485 5.906a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Zm10.5 0a7.826 7.826 0 0 1-.635 3.103.657.657 0 1 1-1.204-.518 6.589 6.589 0 0 0 0-5.17.655.655 0 0 1 .587-.955.656.656 0 0 1 .617.438c.42.98.636 2.036.635 3.102Zm-2.461-2.364a5.92 5.92 0 0 1 0 4.729.657.657 0 0 1-1.204-.526 4.612 4.612 0 0 0 0-3.677.657.657 0 0 1 1.204-.526Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M.203 0h14v14h-14z" />
      </clipPath>
    </defs>
  </svg>
);
